import React from 'react';

interface LocationsIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Ubicaciones"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Un marcador de ubicación (pin) tradicional
 * - Forma de gota alargada con punta afilada en la parte inferior
 * - Círculo pequeño en el centro que representa el punto exacto
 * - Similar a los marcadores de Google Maps o GPS
 * - Representa ubicación geográfica o posición física
 * - Estilo minimalista, icono universalmente reconocido
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const LocationsIcon: React.FC<LocationsIconProps> = ({
  className = '',
  size = 120,
}) => {
  return (
    <svg
      width={(size * 112) / 150}
      height={size}
      viewBox="0 0 112 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.66667 54.932C4.66667 27.233 27.5625 4.66019 56 4.66019C84.4375 4.66019 107.333 27.233 107.333 54.932C107.333 70.9515 99.1667 89.0971 88.6958 105.67C78.3125 122.068 66.0917 136.223 58.8875 144.058C57.2833 145.806 54.7167 145.806 53.1417 144.058C45.9083 136.223 33.6875 122.068 23.3042 105.67C12.8333 89.1262 4.66667 70.9515 4.66667 54.932ZM56 0C25.0833 0 0 24.5825 0 54.932C0 89.6796 35.0583 131.33 49.7 147.204C53.1417 150.932 58.8583 150.932 62.3 147.204C76.9417 131.33 112 89.6796 112 54.932C112 24.5825 86.9167 0 56 0ZM56 79.2233C68.8917 79.2233 79.3333 68.7961 79.3333 55.9223C79.3333 43.0485 68.8917 32.6214 56 32.6214C43.1083 32.6214 32.6667 43.0485 32.6667 55.9223C32.6667 68.7961 43.1083 79.2233 56 79.2233ZM37.3333 55.9223C37.3333 45.6408 45.7042 37.2816 56 37.2816C66.2958 37.2816 74.6667 45.6408 74.6667 55.9223C74.6667 66.2039 66.2958 74.5631 56 74.5631C45.7042 74.5631 37.3333 66.2039 37.3333 55.9223Z"
        fill="currentColor"
      />
    </svg>
  );
};

